import { DEFAULT_LANGUAGE } from '../../constants/languages';

class LocalStorageUser {
  constructor(authUser = {}) {
    this.uid = authUser.uid || '';
    this.language = authUser.language || DEFAULT_LANGUAGE;
    this.isDarkMode = authUser.isDarkMode || false;
  }
}

export default LocalStorageUser;
